module.exports = __webpack_public_path__ + "static/media/ECI88_Share.2a26861f.png";